import { useMediaQuery } from './useMediaQuery';

export function useIsDesktopNavigation(): boolean {
  const desktopNavigationMediaQuery = '(min-width: 1024px)';
  return useMediaQuery(desktopNavigationMediaQuery);
}
